import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

// Team capacity from the content pack (spec §5.7): read-only.
export const Route = createFileRoute('/_authed/leads/capacity')({
  component: lazyRouteComponent(
    () => import('../../../features/leads/screens.tsx'),
    'LeadsCapacity',
  ),
});
